export function createMap(){
    
    var divMap = document.getElementById('map');

     if (!divMap) {
        return; 
    }

    var mapaSel = divMap.getAttribute('data-map');
    if (mapaSel == 'altea') {
        mapAltea();
    } else if (mapaSel == 'benisa') {
        mapBenisa();
    } else if (mapaSel == 'torre')  {
        mapTorre();
    }
}

function mapAltea() {
    var opts = {
        center: {
            lat: 38.634311,
            lng: -0.02177,
        },
        zoom: 14,
        styles: [],
        maxZoom: 20,
        minZoom: 0,
        mapTypeId: 'roadmap',
    };


    opts.clickableIcons = true;
    opts.disableDoubleClickZoom = false;
    opts.draggable = true;
    opts.keyboardShortcuts = true;
    opts.scrollwheel = true;


    var divMap = document.getElementById('map');
    var map = new google.maps.Map(divMap, opts);

    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.642711,
                lng: -0.017184,
            }
        };

        markerOptions.icon = {
            url: 'https://snazzy-maps-cdn.azureedge.net/assets/marker-f76b0e85-9330-4ddf-83cf-efcb150385a6.png',
            scaledSize: new google.maps.Size(
                55,
                80),
            size: new google.maps.Size(
                55,
                80),
            anchor: new google.maps.Point(
                28,
                80)
        };
        markerOptions.options = {
            optimized: true,
        };
        var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.629873,
                lng: -0.012848,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.634088,
                lng: -0.037652,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.630121,
                lng: -0.001932,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.628522,
                lng: -0.009544,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.625304,
                lng: -0.017756,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.640027,
                lng: -0.013256,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.630339,
                lng: -0.044081,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.630623,
                lng: -0.017691,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();

    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.632659,
                lng: -0.013971,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
}

function mapBenisa(){
    var opts = {
        center: {
            lat: 38.676742,
            lng: 0.072207,
        },
        zoom: 14,
        styles: [],
        maxZoom: 20,
        minZoom: 0,
        mapTypeId: 'roadmap',
    };


    opts.clickableIcons = true;
    opts.disableDoubleClickZoom = false;
    opts.draggable = true;
    opts.keyboardShortcuts = true;
    opts.scrollwheel = true;

    var divMap = document.getElementById('map');
    var map = new google.maps.Map(divMap, opts);


    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.677622,
                lng: 0.07186,
            }
        };

        markerOptions.icon = {
            url: 'https://snazzy-maps-cdn.azureedge.net/assets/marker-93f52acc-3d6f-4ded-82d5-b79be01af518.png',
            scaledSize: new google.maps.Size(
                55,
                80),
            size: new google.maps.Size(
                55,
                80),
            anchor: new google.maps.Point(
                28,
                80)
        };
        markerOptions.options = {
            optimized: true,
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.669334,
                lng: 0.093727,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.671252,
                lng: 0.097868,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.673991,
                lng: 0.101602,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.675961,
                lng: 0.096835,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.675065,
                lng: 0.096492,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.678566,
                lng: 0.075538,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.670171,
                lng: 0.069684,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.686905,
                lng: 0.085205,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.676168,
                lng: 0.084326,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.678463,
                lng: 0.0913,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 38.692474,
                lng: 0.078655,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
}
 
function mapTorre(){
    var opts = {
        center: {
            lat: 39.564331,
            lng: -0.466944,
        },
        zoom: 14,
        styles: [],
        maxZoom: 20,
        minZoom: 0,
        mapTypeId: 'roadmap',
    };


        opts.clickableIcons = true;
        opts.disableDoubleClickZoom = false;
        opts.draggable = true;
        opts.keyboardShortcuts = true;
        opts.scrollwheel = true;
    

    var map = new google.maps.Map(document.getElementById('map'), opts);


    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.564331,
                lng: -0.466944,
            }
        };

        markerOptions.icon = {
            url: 'https://snazzy-maps-cdn.azureedge.net/assets/marker-8861c655-ebf1-41a1-b2ed-70d738499c67.png',
            scaledSize: new google.maps.Size(
                60,
                85),
            size: new google.maps.Size(
                60,
                85),
            anchor: new google.maps.Point(
                31,
                85)
        };
        markerOptions.options = {
            optimized: true,
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.567252,
                lng: -0.474124,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.577423,
                lng: -0.472902,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.580484,
                lng: -0.47412,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.567316,
                lng: -0.476342,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.566465,
                lng: -0.473404,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.567252,
                lng: -0.474124,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.576676,
                lng: -0.483167,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.550302,
                lng: -0.460405,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.542989,
                lng: -0.454541,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
    (function(){
        var markerOptions = {
            map: map,
            position: {
                lat: 39.585424,
                lng: -0.457733,
            }
        };

        markerOptions.icon = {
            path: 'M11 2c-3.9 0-7 3.1-7 7 0 5.3 7 13 7 13 0 0 7-7.7 7-13 0-3.9-3.1-7-7-7Zm0 9.5c-1.4 0-2.5-1.1-2.5-2.5 0-1.4 1.1-2.5 2.5-2.5 1.4 0 2.5 1.1 2.5 2.5 0 1.4-1.1 2.5-2.5 2.5Z',
            scale: 1.6363636363636363636363636364,
            anchor: new google.maps.Point(11, 22),
            fillOpacity: 1,
            fillColor: '#8095a1',
            strokeOpacity: 0
        };
                            var marker = new google.maps.Marker(markerOptions);


    })();
    
}
  
window.createMap = createMap;
